module.exports = __webpack_public_path__ + "static/media/envelope_health_score_gauge.22bfe47b.svg";